const gates = document.querySelectorAll('[data-page-password-gate]');

gates.forEach((gate) => {
  const scope = gate.closest('.page-password-protected') || document.documentElement;
  const form = gate.querySelector('[data-page-password-form]');
  const error = gate.querySelector('[data-page-password-error]');
  const input = form?.elements.password;
  const password = gate.dataset.password || '';
  const pageHandle = gate.dataset.pageHandle || window.location.pathname;
  const storageKey = `page-password:${pageHandle}`;

  function unlock() {
    scope.classList.add('page-password-unlocked');
    document.documentElement.classList.add('page-password-unlocked');
    scope.querySelectorAll('.page-password-content[aria-hidden="true"]').forEach((content) => {
      content.removeAttribute('aria-hidden');
    });
  }

  if (!form || !input || !password) {
    return;
  } 

  if (window.sessionStorage.getItem(storageKey) === password) {
    unlock();
    return;
  }

  input.focus();

  form.addEventListener('submit', (event) => {
    event.preventDefault();

    if (input.value === password) {
      window.sessionStorage.setItem(storageKey, password);
      unlock();
      return;
    }

    if (error) {
      error.hidden = false;
    }

    input.setAttribute('aria-invalid', 'true');
    input.select();
  });
});
